export default __webpack_public_path__ + "static/media/olimpusheading.7f1a4a66.png";